export const referrerURL = document.referrer;
